import React, { useEffect } from "react";
import { connect } from 'react-redux'
import { Row,Col,Table,Button,Card,CardHeader,CardBody } from "reactstrap"
import { Link } from 'react-router-dom'
import _ from "lodash"

import DefaultDataGrid from "modules/5_view_helpers/web/DefaultDataGrid"
import columns from "./columns"

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized"
import HasRole from "modules/5_view_helpers/HasRole"

// Actions
import { getWorkshops } from "../actions"



function mapStateToProps(state) {
	return {
		workshops:state.workshops,
	}
}

const WorkshopsIndex = (props) => {
	useEffect(() => {
		props.getWorkshops()
	},[])

	const { workshops } = props

	const readRole = HasRole({resource_type:"Workshop",name:["read","moderator"]})
	const createRole = HasRole({resource_type:"Workshop",name:["create","moderator"]})
	const updateRole = HasRole({resource_type:"Workshop",name:["update","moderator"]})

	


	if (!readRole) {
		return <NotAuthorized />;
	}
	else{
		return (
			<Card>
				<CardHeader>
					<Row>
						<Col><h3>Workshops</h3></Col>
					</Row>
				</CardHeader>

				<CardBody>
					
					{createRole && (<Row>
						<Col>
							<Link to={`/workshops/new`}>
								<Button color="primary" size="md"><i className="fa fa-plus"> Create New Workshop</i></Button>
							</Link>
						</Col>
					</Row>)}


					<Row className="mt-2">
						<Col>
							<DefaultDataGrid 
								columns={columns(updateRole)}
								data={workshops}
							/>
						</Col>
					</Row>
				</CardBody>
			</Card>
		);
	}
}
export default connect(mapStateToProps,{getWorkshops})(WorkshopsIndex)

